/* lua.js generated code 0.3.0 */

var Event = require("cocos/framework/components/event")
var PreProps = xClass("PreProps", Event)
PrePropsEvent = table([1, "Select", "PREPROPSEVENT.SELECT"], [1, "Cancel", "PREPROPSEVENT.CANCEL"])
PreProps.prototype.ctor = function (ui, config) {
    var self = this
    self.playingErrorAnim = false
    self.enabled = true
    self.useRmb = false
    self.bind(self)
    self.init(ui, config)
}
PreProps.prototype.init = function (ui, config) {
    var self = this
    self.config = config
    self.ui = ui
    //ui.disableIcon.setVisible(false)
    ui.checkmark.setVisible(false)
    if (config) {
        if (config.locked) {
            self.buildLockedBubble(ui, config)
        } else if (config.lockedNeedPassLevel) {
            self.buildNeedPassLevelBubble(ui, config)
        } else if(config.litmitedProp) {//限时限次道具
            self.buildLitmitedBubble(ui, config)
        } else if (config.expireTime){ //限时无限次道具
            self.buildInfinityBubble(ui, config)
        } else{
            self.buildNormalBubble(ui, config)
        }
    } else {
        ui.bubbleIdle.setVisible(false)
        ui.bubblePop.setVisible(false)
        ui.lock.setVisible(false)
        //ui.tab.setVisible(false)
        ui.bubbleLock.setVisible(false)
        //ui.num.setVisible(false)
    }
    self.setTouchEvent()
}
PreProps.prototype.buildBubbleLabel = function (state, config) {
    var self = this
    var bubble = self.ui.bubble
    
    bubble.getChildByName("selected").setVisible(false)
    bubble.getChildByName("use").setVisible(false)
    bubble.getChildByName("num").setVisible(false)
    bubble.getChildByName("num").setContentSize(85, 30)
    // bubble.getChildByName("num").y = -5
    
    bubble.labelBg.setVisible(false)
    bubble.getChildByName("props_silvercoin").setVisible(false)
    bubble.getChildByName("props_goldcoin").setVisible(false)
    // bubble.getChildByName("props_goldcoin").y = -95

    // bubble.getChildByName("selected").setFontWeight("bold")
    // bubble.getChildByName("selected").setPosition(43, -160)
    bubble.getChildByName("selected").setScale(1.2)
    // bubble.getChildByName("selected").width = 150
    bubble.getChildByName("selected").setPosition(0, -125)
    // bubble.getChildByName("selected").setPosition(-30, -115)

    // bubble.getChildByName("use").setFontWeight("bold")
    // bubble.getChildByName("use").setPosition(43, -160)
    bubble.getChildByName("use").setScale(1.2)
    // bubble.getChildByName("use").width = 150
    bubble.getChildByName("use").setPosition(0, -125)

    bubble.getChildByName("num").setScale(1.05)
    bubble.getChildByName("num").setFontWeight("bold")
    bubble.getChildByName("num").y = -115
    // bubble.getChildByName("num").setColor(cc.c3b(178, 102, 56))
    
    // bubble.getChildByName("lock_lab").setFontWeight("bold")
    bubble.getChildByName("lock_lab").setScale(1.2)
    bubble.getChildByName("lock_lab").width = 150
    bubble.getChildByName("lock_lab").setPosition(50, -125)
    bubble.getChildByName("lock_lab").setVisible(false)

    var ui = self.ui
    ui.numLabel.textAdd.setVisible(false)
    ui.numLabel.setVisible(false)
    if (state == "use"){ //可使用
        
        bubble.getChildByName("use").setVisible(true)
        bubble.labelBg.setVisible(true)
        //右上角绿色数量标记
        formatIcon()
    }else if (state == "buy"){ //可购买
        //右上角绿色+标记
        ui.numLabel.setVisible(true)
        ui.numLabel.text.x = 14
        ui.numLabel.text.y = -7
        ui.numLabel.text.setScale(1.5)
        ui.numLabel.text.setString("+")
        //label
        bubble.labelBg.setVisible(true)
        bubble.getChildByName("props_silvercoin").setVisible(config.coin)
        bubble.getChildByName("props_goldcoin").setVisible(config.cash)
        bubble.getChildByName("num").setVisible(true)

        var price = ItemDataManager.getItemDataById(config.propId[0]).price
        bubble.getChildByName("num").setString(price)

    }else if (state == "select"){ //已选择
        bubble.getChildByName("selected").setVisible(true)
        bubble.labelBg.setVisible(true)
    }else if (state == "lock"){ //锁定
        //只显示右上角绿色数量标记
        // formatIcon()
        bubble.labelBg.setVisible(true)
        bubble.getChildByName("lock_lab").setVisible(true)

    }

    function formatIcon() {
        ui.numLabel.setVisible(true)
        ui.numLabel.text.setScale(1.1)
        ui.numLabel.textAdd.setScale(1.1)
        if (config.num && config.num > 99) {
            ui.numLabel.text.setString("99")
            ui.numLabel.textAdd.setVisible(true)
            ui.numLabel.textAdd.y = -15
            ui.numLabel.text.x = 8
            ui.numLabel.text.y = -12
        } else {
            ui.numLabel.text.setString(config.num)
            ui.numLabel.text.x = config.num < 10 ? 17 : 12
            ui.numLabel.text.y = -12

        }  
    }
}
/**
 * 创建无限道具气泡
 * @param ui        气泡UI
 * @param config    道具信息
 */
PreProps.prototype.buildInfinityBubble = function (ui, config) {
    var self = this
    // ui.bubbleIdle.getChildByName("light").setVisible(false)
    self.buildNormalBubble(ui, config) 
    // let icon = UIItemBuilder.createPropInfiniteTag()
    let icon = cc.Sprite.createWithSpriteFrameName("level_difficulty/wuxian.png")
    icon.setLocalZOrder(90)
    icon.setScale(0.9)
    icon.setPosition(50, 50)
    ui.numLabel.setVisible(false)
    ui.checkmark.setVisible(true)
    // ui.checkmark.setScale(0)
    ui.bubble.addChild(icon)
    ui.bubbleIdle.setVisible(false)

    ui.bubble.labelBg.setSpriteFrame(cc.spriteFrameCache.getSpriteFrame("level_difficulty/xianshi.png"))
    let littleclockicon = cc.Sprite.createWithSpriteFrameName("level_difficulty/timeicon.png")
    littleclockicon.setPosition(30, 30)
    ui.bubble.labelBg.addChild(littleclockicon)

    // self.buildBubbleLabel("use", config)
    let bubble = ui.bubble
    bubble.getChildByName("selected").setVisible(false)
    bubble.getChildByName("use").setVisible(false)
    bubble.getChildByName("num").setVisible(false)
    // bubble.getChildByName("num").setContentSize(85, 30)
    
    // bubble.labelBg.setVisible(false)
    bubble.getChildByName("props_silvercoin").setVisible(false)
    bubble.getChildByName("props_goldcoin").setVisible(false)

    ui.bubbleIdle.setVisible(false)
    ui.bubblePop.setVisible(true)
    ui.backgrnd.setVisible(true)
    ui.bubblePop.action.gotoFrameAndPlay(0, false)
    ui.numLabel.setVisible(false)
    ui.checkmark.setVisible(true)
    ui.checkmark.setScale(0)
    ui.checkmark.runAction(cc.EaseBackOut.create(cc.ScaleTo.create(0.25, 1)))
    ui.checkmark.setLocalZOrder(99)
    // ui.bubble.getChildByName("num").setColor(221, 164, 232)

    let text = cloneUINode(bubble.getChildByName("num"))
    text.setScale(1.4)
    text.setPosition(96, 38)
    text.setFontWeight("bold")
    text.setAnchorPoint(0.5, 1)
    text.setColor(cc.c3b(255, 255, 255))
    ui.bubble.labelBg.addChild(text)

    let node = cc.Node.create()
    ui.bubble.addChild(node)
    node.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.CallFunc.create(function () {
        let now = Localhost.time()
        let timeInMSec = config.expireTime - now
        text.setString(UIUtils.formatCountDownTime(timeInMSec))
        if (timeInMSec <= 0){
            // text.setString("00:00")
            node.stopAllActions()
        }
    }), cc.DelayTime.create(1))))
    

}

/**
 * 创建限时限次气泡
 * @param ui        气泡UI
 * @param config    道具信息
 */
PreProps.prototype.buildLitmitedBubble = function (ui, config) {
    var self = this
    self.buildNormalBubble(ui, config) 
    let bubble = ui.bubble
    bubble.labelBg.setOpacity(0)
    let litmitedBg =  cc.Node.create()
    litmitedBg.setContentSize(159,55);
    let node1 = cc.Sprite.createWithSpriteFrameName("level_difficulty/litmitedBg.png")
    litmitedBg.addChild(node1)
    litmitedBg.setName("litmitedBg")
    litmitedBg.setPosition(bubble.x,-118.5)
    litmitedBg.setScale(1.1065);
    self.litmitedBg = litmitedBg;
    bubble.getParent().addChild(litmitedBg)
    // self.litmitedBg.setVisible(true)

    let littleclockicon = cc.Sprite.createWithSpriteFrameName("level_difficulty/timeicon.png")
    littleclockicon.setPosition(-50, 0)
    self.litmitedBg.addChild(littleclockicon)

    bubble.getChildByName("use").setOpacity(0)
    bubble.getChildByName("selected").setOpacity(0)
    let text = cloneUINode(bubble.getChildByName("num"))
    text.setScale(1.4)
    text.setPosition(16, 10.5)
    text.setFontWeight("bold")
    text.setAnchorPoint(0.5, 1)
    text.setColor(cc.c3b(255, 255, 255))
    self.litmitedBg.addChild(text)

    let node = cc.Node.create()
    ui.bubble.addChild(node)
    node.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.CallFunc.create(function () {
        let now = Localhost.time()
        let timeInMSec = config.expireTime - now
        text.setString(UIUtils.formatCountDownTime(timeInMSec))
        if (timeInMSec <= 0){
            node.stopAllActions()
        }
    }), cc.DelayTime.create(1))))
}
/**
 * 创建可使用的道具气泡
 * @param ui        气泡UI
 * @param config    道具信息
 */
PreProps.prototype.buildNormalBubble = function (ui, config) {
    var self = this
    //  Idle动画
    self.replaceProp(ui.bubbleIdle, config.itemId)
    //动画异常修改
    // ui.bubbleIdle.getChildByName("light").setVisible(false)
    
    var action = cc.CSLoader.createTimeline("cocos/level_difficulty_bubble_idle.csb")
    ui.bubbleIdle.runAction(action)
    ui.bubbleIdle.action = action
    action.gotoFrameAndPlay(0)
    //  被点击动画
    self.replaceProp(ui.bubblePop, config.itemId)
    var daoju = ui.bubblePop.getChildByName("daoju")
    daoju.setPositionX(daoju.getPositionX() + 2)
    daoju.setPositionY(daoju.getPositionY() - 2)
    ui.backgrnd.setVisible(false)
    ui.bubbleIdle = UIButton.create(ui.bubbleIdle)

    var action = cc.CSLoader.createTimeline("cocos/level_difficulty_bubble_pop.csb")
    ui.bubblePop.runAction(action)
    ui.bubblePop.action = action
    ui.bubblePop.setVisible(false)
    ui.lock.setVisible(false)
    ui.bubbleLock.setVisible(false)

    self.replaceProp(ui.bubbleAppear, config.itemId)

    let actionAppear = cc.CSLoader.createTimeline("cocos/level_difficulty_bubble_appear.csb")
    ui.bubbleAppear.runAction(actionAppear)
    ui.bubbleAppear.action = actionAppear
    ui.bubbleAppear.setVisible(false)


    if (config.num > 0) {
        //ui.num.ignoreContentAdaptWithSize(true)
        //ui.num.setString("免费")
        //ui.num.setTextColor(cc.c4b(255, 255, 255, 255))
        //ui.numLabel.setVisible(true)
        self.buildBubbleLabel("use", config)

        //ui.tab.getChildByName("props_silvercoin").setVisible(false)
    } else if (config.coin || config.cash) {
        self.buildBubbleLabel("buy", config)
        
        //var width = ui.bubbleIdle.getChildByName("daoju").getContentSize().width
        //ui.num.ignoreContentAdaptWithSize(true)
        //var size = ui.num.getVirtualRendererSize()
        //var totalWidth = width * ui.bubbleIdle.getChildByName("daoju").getScaleX() + size.width
        //var cSize = ui.tab.getContentSize()
        //var newSize = cc.size(totalWidth + 20, cSize.height)
        //ui.tab.setContentSize(newSize)
    } else {
        //ui.tab.setVisible(false)
        //ui.num.setVisible(false)
        self.buildBubbleLabel()
        ui.numLabel.text.setString("0")
        ui.numLabel.text.setScale(1.1)
    }
    
}
PreProps.prototype.updateNum = function (newNum) {
    var self = this
    var config = self.config || table()
    if (config.locked || config.lockedNeedPassLevel) {
        return 
    }
    if (newNum === config.num) {
        return 
    }
    var ui = self.ui
    if (config.num === 0 && newNum > 0) {
        //  道具由无到有
        self.useRmb = false
        config.num = newNum
        self.buildBubbleLabel("use", config)
        // ui.numLabel.text.setScale(1.1)
        // ui.numLabel.text.setString(config.num)
        //ui.icon.setVisible(false)
        //ui.rmbSymbol.setVisible(false)
        //ui.num.ignoreContentAdaptWithSize(true)
        //ui.num.setString("x" + tostring(config.num))
        //var size = ui.num.getContentSize()
        //var tSize = ui.tab.getContentSize()
        //ui.num.setPosition(cc.p(ui.tab.getPositionX() + tSize.width / 2 - size.width / 2, ui.tab.getPositionY() - tSize.height / 2 + size.height / 2))
        //ui.tab.setContentSize(cc.size(Math.max(size.width + 20, 140), tSize.height))
        //var aSize = ui.tab.getContentSize()
        //ui.tab.setPosition(ui.tab.getPositionX() + tSize.width / 2 - aSize.width / 2, ui.tab.getPositionY() - tSize.height / 2 + aSize.height / 2)
    } else if (config.num > 0 && newNum === 0) {
        //暂时不会触发，道具用完了
        config.num = newNum
        // ui.numLabel.text.setScale(1.3)
        // ui.numLabel.text.setString("+")
        self.buildBubbleLabel("buy", config)
    } else {
        //  道具变多了
        config.num = newNum
        // ui.numLabel.text.setScale(1.1)
        // ui.numLabel.text.setString(config.num)
        self.buildBubbleLabel("use", config)
    }
}
PreProps.prototype.buildLockedBubble = function (ui, config) {
    var self = this
    self.replaceProp(ui.bubbleLock, config.itemId, true)
    ui.bubblePop.setVisible(false)
    ui.bubbleIdle.setVisible(false)
    ui.backgrnd.setVisible(false)

    // var shadow = ui.bubbleLock.getChildByName("bubble2")
    // shadow.setScale(0.9)
    // shadow.setPosition(cc.p(shadow.getPositionX() - 5, shadow.getPositionY() + 5))
    if (config.num > 0) {
        //ui.num.ignoreContentAdaptWithSize(true)
        //ui.num.setString("x" + tostring(config.num))
        //var size = ui.num.getContentSize()
        //var tSize = ui.tab.getContentSize()
        //ui.num.setPositionX(ui.tab.getPositionX() + tSize.width / 2 - size.width / 2)
        //ui.tab.setContentSize(cc.size(Math.max(size.width + 20, 140), tSize.height))
        //ui.tab.getChildByName("props_silvercoin").setVisible(false)
        // ui.numLabel.text.setScale(1.1)
        // if (config.num > 99) {
        //     ui.numLabel.text.setString("99+")
        // } else {
        //     ui.numLabel.text.setString(config.num)
        // }  
        self.buildBubbleLabel("lock", config)
    } else {
        //ui.tab.setVisible(false)
        // ui.numLabel.setVisible(false)
        self.buildBubbleLabel("lock")
    }
}
PreProps.prototype.buildNeedPassLevelBubble = function (ui, config) {
    var self = this
    // body
    self.replaceProp(ui.bubbleLock, config.itemId, false, true)
    //self.replaceProp(ui.bubbleTap, config.itemId, false, true)
    ui.bubbleLock = UIButton.create(ui.bubbleLock)
    var shadow = ui.bubbleLock.getChildByName("bubble2")
    shadow.setScale(0.9)
    shadow.setPosition(cc.p(shadow.getPositionX() - 5, shadow.getPositionY() + 5))
    //ui.bubbleLock.getChildByName("bubble2").setVisible(false)
    ui.bubbleIdle.setVisible(false)
    ui.bubblePop.setVisible(false)
    ui.backgrnd.setVisible(false)
    ui.lock.setVisible(false)
    var prop = ui.bubbleLock.getChildByName("daoju")
    prop.setGroupRenderPass(0, "advanced_color", table([1, "u_rate", table(
            0.28,
            0.28,
            0.28,
            1
        )], [1, "u_delta", table(
            [0, 164 / 255],
            [0, 117 / 255],
            [0, 71 / 255],
            0
        )]))
    if (config.num > 0) {
        ui.numLabel.text.setScale(1.1)
        if (config.num > 99) {
            ui.numLabel.text.setString("99+")
        } else {
            ui.numLabel.text.setString(config.num)
        }  
        //ui.num.ignoreContentAdaptWithSize(true)
        //ui.num.setString("x" + tostring(config.num))
        //var size = ui.num.getContentSize()
        //var tSize = ui.tab.getContentSize()
        //ui.num.setPositionX(tSize.width / 2)
        //ui.tab.setContentSize(cc.size(Math.max(size.width + 20, 140), tSize.height))
        //var aSize = ui.tab.getContentSize()
        //ui.tab.setPosition(ui.tab.getPositionX() + tSize.width / 2 - aSize.width / 2, ui.tab.getPositionY() - tSize.height / 2 + aSize.height / 2)
        //ui.tab.getChildByName("props_silvercoin").setVisible(false)
    } else {
        //ui.tab.setVisible(false)
        ui.numLabel.setVisible(false)
    }
}
/**
 * 替换气泡内道具图标
 */
PreProps.prototype.replaceProp = function (target, propId, disabled, noShadow) {
    var self = this
    var ph = target.getChildByName("daoju")
    var size = ph.getContentSize()
    var scale = ph.getScaleX()
    var sprite = UIItemBuilder.createPropIcon(propId)
    if (disabled) {
        sprite.setColor(cc.c4b(130, 130, 130, 128))
    }
    sprite.setScale(size.width * scale / sprite.getContentSize().width)
    sprite.setPosition(cc.p(size.width * scale / 2, size.height * ph.getScaleY() / 2))
    ph.setSpriteFrame(sprite.getSpriteFrame())
    ph.setColor(sprite.getColor())
}
// PreProps.prototype.setCanAfford = function (afford) {
//     var self = this
//     // if (self.locked || self.selected) {
//     //     afford = true
//     // }
//     // if (afford) {
//     //     //self.ui.num.setColor(cc.c4b(255, 255, 255, 255))
//     // } else {
//     //     //self.ui.num.setColor(cc.c4b(229, 0, 0, 255))
//     // }
// }
PreProps.prototype.setRmbPrice = function (rmb) {
    var self = this
    if (self.selected || self.useRmb) {
        return 
    }
    if (self.config.locked || self.config.lockedNeedPassLevel) {
        return 
    }
    self.useRmb = true
    //self.ui.icon.setVisible(false)
    //self.ui.rmbSymbol.setVisible(true)
    var ui = self.ui
    //ui.icon.removeAllChildren()
    //var size = ui.num.getContentSize()
    //var tSize = ui.tab.getContentSize()
    //var width = ui.icon.getContentSize().width
    //ui.rmbSymbol.setPositionX(self.ui.tab.getPositionX() + width * self.ui.icon.getScale() / 2 - 5)
    //ui.num.setString(string.format("%.2f", rmb / 100))
    //var rmbSymbolWidth = ui.rmbSymbol.getContentSize().width
    //ui.num.ignoreContentAdaptWithSize(true)
    //var size = ui.num.getVirtualRendererSize()
    //var totalWidth = width * ui.icon.getScaleX() + size.width
    //var cSize = ui.tab.getContentSize()
    //var newSize = cc.size(totalWidth + 20, cSize.height)
    //ui.tab.setContentSize(newSize)
    //ui.tab.setPositionX(ui.tab.getPositionX() + (cSize.width - newSize.width) / 2)
    //ui.num.setPositionX(ui.rmbSymbol.getPositionX() + rmbSymbolWidth * ui.rmbSymbol.getScale() / 2)
}
PreProps.prototype.select = function (value) {
    var self = this
    if (value) {
        self.ui.bubbleIdle.setVisible(false)
        self.ui.bubblePop.setVisible(true)
        self.ui.backgrnd.setVisible(true)
        self.ui.bubblePop.action.gotoFrameAndPlay(0, false)
        self.ui.numLabel.setVisible(false)
        self.ui.checkmark.setVisible(true)
        self.ui.checkmark.setScale(0)
        self.ui.checkmark.runAction(cc.EaseBackOut.create(cc.ScaleTo.create(0.25, 1)))
        self.buildBubbleLabel("select")

    } else {
        self.ui.checkmark.setVisible(false)
        self.ui.numLabel.setVisible(true)
        self.ui.backgrnd.setVisible(false)
        // if (self.config.num > 0) {
        //     self.ui.numLabel.setVisible(true)
        // } else {
        //     //let coin = self.ui.tab.getChildByName("props_silvercoin")
        //     //coin.setVisible(true)
        // }
        // 
        self.ui.bubblePop.setVisible(false)
        self.ui.bubbleIdle.setVisible(true)

        // self.ui.bubbleAppear.setVisible(true)
        // self.ui.bubbleAppear.action.gotoFrameAndPlay(0, false)
        // self.ui.bubbleAppear.action.setLastFrameCallFunc(function(){
        //     self.ui.bubbleAppear.action.clearLastFrameCallFunc()
        //     self.ui.bubbleIdle.setVisible(true)
        //     self.ui.bubbleAppear.setVisible(false)
        // })
        self.buildBubbleLabel("use", self.config)
        //self.ui.num.setVisible(true)
        // if (self.ui.selected) {
        //     self.ui.selected.removeFromParent(true)
        //     self.ui.selected = null
        // }
    }
    self.selected = value
}
PreProps.prototype.isSelected = function () {
    var self = this
    return self.selected
}
PreProps.prototype.showErrorTip = function (errCode) {
    var self = this
    if (self.playingErrorAnim) {
        return 
    }
    self.playingErrorAnim = true
    FrameLoader.loadImageWithPlist("cocos/uilibrary.plist")
    var bg = ccui.Scale9Sprite.createWithSpriteFrameName("uilibrary/bagTipBg.png")
    var text = cc.Label.createWithSystemFont(getText("error.tip." + tostring(errCode)), null, 24, cc.size(250, 0), cc.TEXT_ALIGNMENT_CENTER)
    text.setTextColor(cc.c4b(0, 0, 0, 255))
    var size = text.getContentSize()
    bg.setContentSize(cc.size(size.width + 57, Math.max(size.height + 37, 94)))
    var bSize = bg.getContentSize()
    text.setPosition(cc.p((bSize.width - 7) / 2, (bSize.height - size.height) / 2 + size.height / 2))
    bg.addChild(text)
    bg.setAnchorPoint(cc.p((bSize.width - 7) / 2 / bSize.width, (bSize.height / 2 + 7) / bSize.height))
    bg.setPosition(cc.p(self.ui.bubble.getPositionX() + self.ui.bubble.getContentSize().width / 2, -270))
    var parent = self.ui.bubble.getParent().getParent()
    if (parent) {
        parent.addChild(bg)
        bg.setLocalZOrder(200)
        bg.setOpacity(0)
        bg.setScale(0)
        bg.runAction(cc.Sequence.create(cc.DelayTime.create(0.1), cc.Spawn.create(cc.EaseBackOut.create(cc.ScaleTo.create(0.25, 1)), cc.FadeIn.create(0.25), cc.EaseBackOut.create(cc.MoveBy.create(0.25, cc.p(0, 90)))), cc.DelayTime.create(1), cc.Spawn.create(cc.FadeOut.create(0.25), cc.ScaleTo.create(0.25, 0), cc.MoveBy.create(0.25, cc.p(0, -90))), cc.CallFunc.create(function () {
            bg.removeFromParent(true)
            self.playingErrorAnim = false
        })))
    }
}
PreProps.prototype.setEnabled = function (bool) {
    var self = this
    self.enabled = bool
}
PreProps.prototype.setTouchEvent = function () {
    var self = this
    var listenner = cc.EventListenerTouchOneByOne.create()
    listenner.setSwallowTouches(true)
    listenner.registerScriptHandler(function (touch, event) {
        if (!self.enabled) {
            return false
        }
        var size = self.ui.bubbleIdle.getContentSize()
        var wPos = self.ui.bubbleIdle.convertToWorldSpace(cc.p(size.width / 2, size.height / 2))
        if (cc.pGetDistance(wPos, touch.getLocation()) <= 75) {
            // self.ui.bubble.scale = 0.8
            if(self.ui.bubble)self.ui.bubbleIdle.runAction(cc.ScaleTo.create(0.05, 0.85))
            return true
        }
        return false
    }, cc.Handler.EVENT_TOUCH_BEGAN)
    listenner.registerScriptHandler(function (touch, event) { }, cc.Handler.EVENT_TOUCH_MOVED)
    listenner.registerScriptHandler(function (touch, event) {
        var size = self.ui.bubbleIdle.getContentSize()
        var wPos = self.ui.bubbleIdle.convertToWorldSpace(cc.p(size.width / 2, size.height / 2))
        if (cc.pGetDistance(wPos, touch.getLocation()) <= 75) {
            self.onTouched()
        }
        // self.ui.bubble.scale = 1
        // self.ui.bubble.runAction(cc.ScaleTo.create(0.05, 0.8))
        if(self.ui.bubble)self.ui.bubbleIdle.runAction(cc.Sequence.create(cc.ScaleTo.create(0.1, 1.1), cc.ScaleTo.create(0.08, 1)))
    }, cc.Handler.EVENT_TOUCH_ENDED)

    cc.eventManager.addListener(listenner, self.ui.bubbleIdle)
    self.ui.bubbleIdle.listenner = listenner

    let iconBtn = UIButton.create(self.ui.numLabel, true)
    iconBtn.on(UIButtonEvent.Click, function () {
        self.onTouched()
    })
}
PreProps.prototype.onTouched = function () {
    var self = this
    
    if (self.config.locked) {
        self.playLockedAnim()
    } else if (self.config.lockedNeedPassLevel) {
        self.playPassLevelLockedAnim(getText("props.locked.tip" + self.config.index + ".2"))
    } else if (self.selected) {
        self.dispatchEvent(table([1, "name", PrePropsEvent.Cancel]))
        DCAssist.userTrack("stage_start", "click_item", {
            item_id: self.config.itemId,
            state: PrePropsState.IsSelected
        });
    } else if (self.config.cash && self.config.num <= 0) {
        self.dispatchEvent(table([1, "name", PrePropsEvent.Select]))
        DCAssist.userTrack("stage_start", "click_item", {
            item_id: self.config.itemId,
            state: PrePropsState.UnlockButDontHave
        });
    } else {
        self.dispatchEvent(table([1, "name", PrePropsEvent.Select]))
        if (self.config.num > 0) {
            DCAssist.userTrack("stage_start", "click_item", {
                item_id: self.config.itemId,
                state: PrePropsState.UnlockAndHave
            });
        } else {
            DCAssist.userTrack("stage_start", "click_item", {
                item_id: self.config.itemId,
                state: PrePropsState.UnlockButDontHave
            });
        }
    }
}
PreProps.prototype.playPassLevelLockedAnim = function (txt) {
    var self = this
    // body
    if (self.playingErrorAnim) {
        return 
    }
    self.playingErrorAnim = true
    function callback() {
    }
    self.ui.lock.runAction(cc.Sequence.create(cc.MoveBy.create(0.07, cc.p(0, 5)), cc.MoveBy.create(0.07, cc.p(0, -10)), cc.MoveBy.create(0.07, cc.p(0, 10)), cc.MoveBy.create(0.07, cc.p(0, -10)), cc.MoveBy.create(0.07, cc.p(0, 5))))
    var action = cc.Sequence.create(cc.MoveBy.create(0 * 0.8, cc.p(23, 0)), cc.MoveBy.create(0.125 * 0.8, cc.p(-44, 0)), cc.MoveBy.create(0.166 * 0.8, cc.p(45, 0)), cc.MoveBy.create(0.166 * 0.8, cc.p(-39, 0)), cc.MoveBy.create(0.083 * 0.8, cc.p(26, 0)), cc.MoveBy.create(0.083 * 0.8, cc.p(-11, 0)), cc.CallFunc.create(callback))
    self.ui.bubbleLock.runAction(action)
    var disableIcon = cc.Sprite.createWithSpriteFrameName("level_panel/prop_disable_icon.png")
    self.ui.bubbleLock.addChild(disableIcon)
    var size = self.ui.bubbleLock.getContentSize()
    disableIcon.setAnchorPoint(cc.p(0.5, 0.5))
    disableIcon.setPosition(cc.p(size.width / 2, -size.height / 2))
    var iconAction = cc.Sequence.create(cc.DelayTime.create(0.625), cc.FadeOut.create(0.375), cc.ToggleVisibility.create())
    disableIcon.runAction(iconAction)
    FrameLoader.loadImageWithPlist("cocos/uilibrary.plist")
    var bg = ccui.Scale9Sprite.createWithSpriteFrameName("uilibrary/bagTipBg.png")
    var title = ccui.Text.create()
    title.ignoreContentAdaptWithSize(true)
    title.setFontSize(24)
    title.setString(getText("prop.name." + tostring(self.config.itemId)))
    title.setTextColor(cc.c4b(175, 14, 14, 255))
    var tSize = title.getVirtualRendererSize()
    var text = ccui.Text.create()
    text.ignoreContentAdaptWithSize(true)
    text.setFontSize(24)
    text.setString(txt)
    text.setTextColor(cc.c4b(34, 67, 88, 255))
    var dSize = text.getVirtualRendererSize()
    bg.setContentSize(cc.size(Math.max(tSize.width, dSize.width) + 57, tSize.height + dSize.height + 47))
    var bSize = bg.getContentSize()
    title.setPosition(cc.p((bSize.width - 7) / 2, bSize.height - 15 - tSize.height / 2))
    bg.addChild(title)
    text.setPosition(cc.p((bSize.width - 7) / 2, dSize.height / 2 + 22))
    bg.addChild(text)
    bg.setAnchorPoint(cc.p((bSize.width - 7) / 2 / bSize.width, (bSize.height / 2 + 7) / bSize.height))
    bg.setPosition(cc.p(self.ui.bubble.getPositionX() + self.ui.bubble.getContentSize().width / 2, -270))
    var parent = self.ui.bubble.getParent().getParent()
    if (parent) {
        parent.addChild(bg)
        bg.setLocalZOrder(200)
        bg.setOpacity(0)
        bg.setScale(0)
        bg.runAction(cc.Sequence.create(cc.DelayTime.create(0.1), cc.Spawn.create(cc.EaseBackOut.create(cc.ScaleTo.create(0.25, 1)), cc.FadeIn.create(0.25), cc.EaseBackOut.create(cc.MoveBy.create(0.25, cc.p(0, 90)))), cc.DelayTime.create(1), cc.Spawn.create(cc.FadeOut.create(0.25), cc.ScaleTo.create(0.25, 0), cc.MoveBy.create(0.25, cc.p(0, -90))), cc.CallFunc.create(function () {
            bg.removeFromParent(true)
            self.playingErrorAnim = false
        })))
    }
    if (self.config.num > 0) {
        DCAssist.userTrack("stage_start", "click_item", {
            item_id: self.config.itemId,
            state: PrePropsState.LockButHave
        });
    } else {
        DCAssist.userTrack("stage_start", "click_item", {
            item_id: self.config.itemId,
            state: PrePropsState.LockAndDontHave
        });
    }
}
PreProps.prototype.playLockedAnim = function () {
    var self = this
    if (self.playingErrorAnim) {
        return 
    }
    self.playingErrorAnim = true
    self.ui.lock.runAction(cc.Sequence.create(cc.MoveBy.create(0.07, cc.p(0, 5)), cc.MoveBy.create(0.07, cc.p(0, -10)), cc.MoveBy.create(0.07, cc.p(0, 10)), cc.MoveBy.create(0.07, cc.p(0, -10)), cc.MoveBy.create(0.07, cc.p(0, 5))))
    
    FrameLoader.loadImageWithPlist("cocos/uilibrary.plist")
    var bg = ccui.Scale9Sprite.createWithSpriteFrameName("uilibrary/bagTipBg.png")
    var title = ccui.Text.create()
    title.ignoreContentAdaptWithSize(true)
    title.setFontSize(24)
    title.setString(getText("prop.name." + tostring(self.config.itemId)))
    title.setTextColor(cc.c4b(175, 14, 14, 255))
    var tSize = title.getVirtualRendererSize()
    var text = ccui.Text.create()
    text.ignoreContentAdaptWithSize(true)
    text.setFontSize(24)
    let lock_lv = self.config.level
    if (UserManager.getInstance().getGroupByKey(MetaManager.prePropsGuideConfig.ab_test_name) == "b"){
        lock_lv = MetaManager.prePropsGuideConfig.unlock_lv
    }
    var str = getText("props.locked.tip" + self.config.index, table([1, "level_number", tostring(lock_lv)]))
    text.setString(str)
    text.setTextColor(cc.c4b(34, 67, 88, 255))
    var dSize = text.getVirtualRendererSize()
    bg.setContentSize(cc.size(Math.max(tSize.width, dSize.width) + 57, tSize.height + dSize.height + 47))
    var bSize = bg.getContentSize()
    title.setPosition(cc.p((bSize.width - 7) / 2, bSize.height - 15 - tSize.height / 2))
    bg.addChild(title)
    text.setPosition(cc.p((bSize.width - 7) / 2, dSize.height / 2 + 22))
    bg.addChild(text)
    bg.setAnchorPoint(cc.p((bSize.width - 7) / 2 / bSize.width, (bSize.height / 2 + 7) / bSize.height))
    bg.setPosition(cc.p(self.ui.bubble.getPositionX() , 50))
    var parent = self.ui.bubble.getParent().getParent()
    if (parent) {
        parent.addChild(bg)
        bg.setLocalZOrder(200)
        bg.setOpacity(0)
        bg.setScale(0)
        bg.runAction(cc.Sequence.create(cc.DelayTime.create(0.1), cc.Spawn.create(cc.EaseBackOut.create(cc.ScaleTo.create(0.25, 1)), cc.FadeIn.create(0.25), cc.EaseBackOut.create(cc.MoveBy.create(0.25, cc.p(0, 90)))), cc.DelayTime.create(1), cc.Spawn.create(cc.FadeOut.create(0.25), cc.ScaleTo.create(0.25, 0), cc.MoveBy.create(0.25, cc.p(0, -90))), cc.CallFunc.create(function () {
            bg.removeFromParent(true)
            self.playingErrorAnim = false
        })))
    }
    if (self.config.num > 0) {
        DCAssist.userTrack("stage_start", "click_item", {
            item_id: self.config.itemId,
            state: PrePropsState.LockButHave
        });
    } else {
        DCAssist.userTrack("stage_start", "click_item", {
            item_id: self.config.itemId,
            state: PrePropsState.LockAndDontHave
        });
    }
}
PreProps.prototype.getPropPositionAndScaleInWorldSpace = function () {
    var self = this
    var position = self.ui.bubble.convertToWorldSpace(cc.p(0, 0))
    //var anchorPoint = self.ui.icon.getAnchorPoint()
    //var size = self.ui.icon.getContentSize()
    //var v00 = self.ui.icon.convertToWorldSpace(cc.p(-size.width * anchorPoint.x, -size.height * anchorPoint.y))
    //var v11 = self.ui.icon.convertToWorldSpace(cc.p(size.width * (1 - anchorPoint.x), size.height * (1 - anchorPoint.y)))
    //var newSize = cc.size(v11.x - v00.x, v11.y - v00.y)
    // FIXME: multi result
    return [position, newSize.width / size.width, newSize.height / size.height]
}
PreProps.prototype.setPropIconVisible = function (visible) {
    var self = this
    //self.ui.icon.setVisible(visible)
}
// 以下三个函数用于开始面板出现时的放大缩小动画
// 因此在此定义 此时的前置道具一定是没有被选中的
// 如果这个需求被修改了……祝你好运……
PreProps.prototype.startAnim = function () {
    var self = this
    if (self.ui.bubbleIdle.action) {
        self.ui.bubbleIdle.action.resume()
    }
}
PreProps.prototype.stopAnim = function () {
    var self = this
    if (self.ui.bubbleIdle.action) {
        self.ui.bubbleIdle.action.pause()
    }
}
PreProps.prototype.getBubble = function () {
    var self = this
    if (self.config) {
        return self.ui.bubbleIdle
    }
    return null
}
PrePropsState = {
    LockAndDontHave: 0,
    LockButHave: 1,
    UnlockButDontHave: 2,
    UnlockAndHave: 3,
    IsSelected: 4
}
module.exports = table([0, PreProps], [0, PrePropsEvent])
